/*
 * @Desc: 
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: 赵佳明
 * @LastEditTime: 2023-02-02 14:59:11
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
 */
import Vue from 'vue';
import Vuex from 'vuex';

// 用户状态
import user from './modules/user';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    // 所有要管理的module, 都要列在这里.
    modules: {
        user
    },
    strict: debug,
    middlewares: []
});